import React from "react"
import PropTypes from "prop-types"
import OverviewCard from "../OverviewCard"
import { Link } from "react-router-dom"
import ListCardBodyWithData from "./ListCardBodyWithData"
import { getEntityTypeMapping } from "../../helpers/sharedHelperFunctions"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import "./ListCard.scss"
import { ChevronDown } from "react-bootstrap-icons"

const entityTypeToListCardTypes = {
  facility: ["departments", "units", "roles"],
  department: ["staff"],
}

class ListCard extends React.Component {
  constructor(props) {
    super(props)

    this.entityTypes = entityTypeToListCardTypes[props.entityType]

    this.toggle = this.toggle.bind(this)
    this.state = {
      dropdownOpen: false,
      entityType: getEntityTypeMapping(this.entityTypes[0]),
    }
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    })
  }

  setEntityType(entity) {
    this.setState({
      entityType: getEntityTypeMapping(entity),
    })
  }

  render() {
    return (
      <div className="ListCard">
        <OverviewCard>
          <div className="header">
            <div className="card-title semi-bold">{this.props.children}</div>
            <Dropdown
              isOpen={this.state.dropdownOpen}
              toggle={this.toggle}
              hidden={this.entityTypes.length < 2}
            >
              <DropdownToggle>
                {this.state.entityType.pluralShortDisplay}
                <ChevronDown className="margin-left" />
              </DropdownToggle>

              <DropdownMenu role="menuitem" right>
                {this.entityTypes.map(entityType => (
                  <DropdownItem
                    key={entityType}
                    onClick={() => this.setEntityType(entityType)}
                  >
                    {getEntityTypeMapping(entityType).pluralShortDisplay}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
          <ListCardBodyWithData
            entityType={this.props.entityType}
            entityId={this.props.entityId}
            childEntityType={this.state.entityType.pluralField}
            {...this.props}
          />
          <div className="footer">
            <Link
              className="viewAllLink"
              to={{
                pathname: this.state.entityType.pluralRoute,
                state: {
                  onlyComplianceData: true,
                  dataSort: this.props.dataSort,
                },
              }}
            >
              <button>
                View All {this.state.entityType.pluralShortDisplay}
              </button>
            </Link>
          </div>
        </OverviewCard>
      </div>
    )
  }
}

ListCard.propTypes = {
  entityType: PropTypes.oneOf(["facility", "department"]).isRequired,
  entityId: PropTypes.string.isRequired,
  dataSort: PropTypes.string.isRequired,
  children: PropTypes.node,
}

ListCard.defaultProps = {
  dataSort: "DESC",
}

export default ListCard
